const Images = {
  infoboxx_logo: "/images/logo_white.webp",
  hero_img:"/images/hero_img.png",
  underline:"/images/underline.png",

  accident_insurance:"/images/accident.png",
  life_insurance:"/images/life_insurance.png",
  health_insurance:"/images/health_insurance.png",
  fire_insurance:"/images/fire_insurance.png",
  home_insurance:"/images/home_insurance.png",
  travel_insurance:"/images/travel_insurance.png",
  business_insurance:"/images/business_insurance.png",
  personal_banking:"/images/personal_banking.png",
  loan:"/images/loan.png",
  investment:"/images/investment.png",
  business_account:"/images/business_account.png",
  marine_insurance:"/images/marine.png",
  motor_insurance:"/images/car.png",


  // INDUSTRIES
  insurance:"/images/industries/insurances.png",
  investment_wealth:"/images/industries/investments.png",
  everyday_financial_services:"/images/industries/financial_services.png",
  sme_business:"/images/industries/sme_business.png",
  personal_loans_consumer_credit:"/images/industries/loans.png",
  mortgage_real_estate:"/images/industries/mortgage.png",
  digital_financial_services_payments:"/images/industries/digital_payment.png",
  education_financing:"/images/industries/educational_financing.png",
  retirement_pension_planning:"/images/industries/retirement.png",
  financial_planning_advisory:"/images/industries/financial_planning.png",

  // Partner Logos
  ecobank:"/images/partner_logos/ecobank.png",
  enterprise:"/images/partner_logos/enterprise.png",
  gcb:"/images/partner_logos/gcb_bank.png",
  glico:"/images/partner_logos/glico_group.png",
  hollard:"/images/partner_logos/hollard-group.png",
  sic:"/images/partner_logos/sic_group.png",
  stanbic:"/images/partner_logos/stanbic.png",
  zenith:"/images/partner_logos/zenith_bank.png",
  afrimore:"/images/partner_logos/afrimore.png",
}

export default Images;